// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.offline-toast {
  --offline-toast-bottom: calc(var(--app-safe-area-bottom) + 32px);
  position: fixed;
  left: calc(var(--ion-safe-area-left) + 10px);
  right: calc(var(--ion-safe-area-right) + 10px);
  bottom: var(--offline-toast-bottom);
  z-index: 11;
  box-sizing: border-box;
  min-height: 44px;
  padding: 12px 16px;
  border: 0;
  font: inherit;
  color: #fff;
  text-align: center;
  border-radius: 10px;
  background-color: #f32206;
  margin: 0;
  overflow: hidden;
  cursor: pointer;
  transform: translateY(0);
  transition: transform 320ms cubic-bezier(0.22, 1, 0.36, 1), background-color 180ms ease;
}
.offline-toast__message {
  display: block;
}
.offline-toast--collapsed {
  transform: translateY(calc(100% + var(--offline-toast-bottom) - 5px));
}
.offline-toast--entering {
  animation: offline-toast-enter 320ms cubic-bezier(0.22, 1, 0.36, 1);
}
.offline-toast--restored {
  background-color: #187b38;
}
.offline-toast--closing {
  transform: translateY(calc(100% + var(--offline-toast-bottom)));
}

@keyframes offline-toast-enter {
  from {
    transform: translateY(calc(100% + var(--offline-toast-bottom)));
  }
  to {
    transform: translateY(0);
  }
}
:host(.with-footer-menu) .offline-toast {
  --offline-toast-bottom: calc(var(--app-safe-area-bottom) + var(--footer-menu-height) + 48px);
}

@media (prefers-reduced-motion: reduce) {
  .offline-toast {
    transition: none;
    animation: none;
  }
}`, "",{"version":3,"sources":["webpack://./src/app/shared/ui-components/offline-toast/offline-toast.component.scss"],"names":[],"mappings":"AAAA;EACE,gEAAA;EAEA,eAAA;EACA,4CAAA;EACA,8CAAA;EACA,mCAAA;EACA,WAAA;EACA,sBAAA;EACA,gBAAA;EACA,kBAAA;EACA,SAAA;EACA,aAAA;EACA,WAAA;EACA,kBAAA;EACA,mBAAA;EACA,yBAAA;EACA,SAAA;EACA,gBAAA;EACA,eAAA;EACA,wBAAA;EACA,uFAAA;AAAF;AAEE;EACE,cAAA;AAAJ;AAGE;EACE,qEAAA;AADJ;AAIE;EACE,mEAAA;AAFJ;AAKE;EACE,yBAAA;AAHJ;AAME;EACE,+DAAA;AAJJ;;AAQA;EACE;IAAO,+DAAA;EAJP;EAKA;IAAK,wBAAA;EAFL;AACF;AAIA;EAEE,4FAAA;AAHF;;AAMA;EACE;IACE,gBAAA;IACA,eAAA;EAHF;AACF","sourcesContent":[".offline-toast {\n  --offline-toast-bottom: calc(var(--app-safe-area-bottom) + 32px);\n\n  position: fixed;\n  left: calc(var(--ion-safe-area-left) + 10px);\n  right: calc(var(--ion-safe-area-right) + 10px);\n  bottom: var(--offline-toast-bottom);\n  z-index: 11;\n  box-sizing: border-box;\n  min-height: 44px;\n  padding: 12px 16px;\n  border: 0;\n  font: inherit;\n  color: #fff;\n  text-align: center;\n  border-radius: 10px;\n  background-color: #f32206;\n  margin: 0;\n  overflow: hidden;\n  cursor: pointer;\n  transform: translateY(0);\n  transition: transform 320ms cubic-bezier(0.22, 1, 0.36, 1), background-color 180ms ease;\n\n  &__message {\n    display: block;\n  }\n\n  &--collapsed {\n    transform: translateY(calc(100% + var(--offline-toast-bottom) - 5px));\n  }\n\n  &--entering {\n    animation: offline-toast-enter 320ms cubic-bezier(0.22, 1, 0.36, 1);\n  }\n\n  &--restored {\n    background-color: #187b38;\n  }\n\n  &--closing {\n    transform: translateY(calc(100% + var(--offline-toast-bottom)));\n  }\n}\n\n@keyframes offline-toast-enter {\n  from { transform: translateY(calc(100% + var(--offline-toast-bottom))); }\n  to { transform: translateY(0); }\n}\n\n:host(.with-footer-menu) .offline-toast {\n  // Leave clearance above the central menu button, which extends past the footer.\n  --offline-toast-bottom: calc(var(--app-safe-area-bottom) + var(--footer-menu-height) + 48px);\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .offline-toast {\n    transition: none;\n    animation: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
